import { useState, useCallback } from 'react';
import { removeUserReferral } from '../../API/ProtectedAuth';
import { handleApiError } from '../../Utils/errorHandler';

export default function useRemoveReferral({ onSuccess } = {}) {
  const [loadingId, setLoadingId] = useState(null);
  const [error, setError] = useState(null);

  const clearError = useCallback(() => setError(null), []);

  const removeReferral = useCallback(async (userId) => {
    setError(null);
    setLoadingId(userId);
    try {
      await removeUserReferral(userId);
      if (typeof onSuccess === 'function') onSuccess();
    } catch (err) {
      const msg = handleApiError(err);
      setError(msg);
    } finally {
      setLoadingId(null);
    }
  }, [onSuccess]);

  return { removeReferral, loadingId, error, clearError };
}


